import React from 'react';
import './RecipientPreview.css';
import ParticipantGroupDot from '../participant-group/ParticipantGroupDot';

/**
 * Read-only list of mail recipients (name, e-mail, group dot) — e.g. the round mail preview.
 * recipients: rows with id, firstName, lastName, email and the group fields of the row
 * (participantGroupId / roleSnapshot or participantGroup / role), resolved by ParticipantGroupDot.
 * The caller computes the list from data it already has — this component never fetches.
 */
function RecipientPreview({ recipients = [], emptyText = 'Keine Empfänger', ariaLabel = 'Empfänger' }) {
  return (
    <div className="recipientPreviewList" role="list" aria-label={ariaLabel}>
      {recipients.length === 0 ? (
        <p className="recipientPreviewEmpty">{emptyText}</p>
      ) : (
        recipients.map(r => (
          <div key={r.id} className="recipientPreviewItem" role="listitem">
            <ParticipantGroupDot row={r} />
            <span className="recipientPreviewText">
              <span className="recipientPreviewName">{r.firstName} {r.lastName}</span>
              <span className="recipientPreviewEmail">{r.email}</span>
            </span>
          </div>
        ))
      )}
    </div>
  );
}

export default RecipientPreview;
